import React from 'react'
import {graphql, Link} from 'gatsby'
import { Helmet } from "react-helmet"

import Layout from '../components/layout'
import Seo from '../components/seo'
import RecipeList from '../components/RecipeList'
import * as allRecipesStyles from '../pages/vegan-life/allRecipes.module.scss'

export const query = graphql`
    query($name: String, $skip: Int!, $limit: Int!) {
        allContentfulBlogPost (sort: {
            publishedDate: DESC
          },
          filter: {mainIngredient: {elemMatch: {name: {eq: $name}}}},
          skip: $skip,
          limit: $limit
        ) {
            edges {
                node {
                    slug 
                    category {
                        slug
                    }
                    blogTitle
                    thumbnailImage {
                        file {
                            url
                        }
                        imgixImage {
                          gatsbyImageData (width: 800, aspectRatio: 1, layout: FULL_WIDTH, imgixParams: {q: 75, mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
                        }
                        title
                      }
                }
            }
        }
        contentfulMainIngredient (name: {eq: $name}) {
            name
            title
            slug
            metaDescription
            pageDescription {
                childMarkdownRemark {
                    html
                }
            }
        }
    }
`

const Ingredient = (props) =>{
    return (<Layout>
        <Seo 
            title={props.data.contentfulMainIngredient.title}
            description={props.data.contentfulMainIngredient.metaDescription}
            path={`/vegan-life/recipes/${props.data.contentfulMainIngredient.slug}`} 
            image={props.data.allContentfulBlogPost.edges[0].node.thumbnailImage.file.url} 
            imageAlt={props.data.allContentfulBlogPost.edges[0].node.thumbnailImage.title}
            type="article"
            />

            <Helmet>
            <script type="application/ld+json">
             {`
             {
               "@context": "https://schema.org",
               "@type": "ItemList",
               "itemListElement": [${props.data.allContentfulBlogPost.edges.map((edge, index) => {
                return (
                  
                 ` 
                 {
                    "@type": "ListItem",
                    "position": ${index + 1},
                    "url": "https://www.stephsunshine.com/${edge.node.category[0].slug}/${edge.node.slug}"
                  }`
                )
              })}
              ]
             }` } 
             </script>
            </Helmet>

            <div className="ss-container">
                <div className={allRecipesStyles.headingContainer}>
                    <h1 className={allRecipesStyles.heading}>{props.data.contentfulMainIngredient.title}</h1>
                    <div className={allRecipesStyles.text} dangerouslySetInnerHTML={{
                            __html: props.data.contentfulMainIngredient.pageDescription.childMarkdownRemark.html
                            }}></div>
                </div>
                <RecipeList data={props.data.allContentfulBlogPost.edges} />
                {/* Pagination */}

                {props.pageContext.numberOfPages > 1 ? 
                <div>
                    <div className={allRecipesStyles.currentPage}>
                    Page {props.pageContext.pageNumber + 1} of {props.pageContext.numberOfPages}
                    </div>
                            <div className={allRecipesStyles.pagination}>
                                
                                <div className={props.pageContext.pageNumber !== 0 ? allRecipesStyles.left : allRecipesStyles.hidden}>
                    
                                    <Link className={allRecipesStyles.pagButton} to={props.pageContext.previousPagePath}>&larr; Prev</Link> 
                                    </div>
                                    
                                <div className={allRecipesStyles.right}>
                                <div className={props.pageContext.pageNumber + 1 !== props.pageContext.numberOfPages ? allRecipesStyles.right : allRecipesStyles.hidden}>
                                <Link className={allRecipesStyles.pagButton} to={props.pageContext.nextPagePath}>Next &rarr;</Link>
                                </div>
                    
                    </div>
                    <div className={allRecipesStyles.currentPage}>
                                
                                    </div>
                                </div>
                                </div>
                            : <div></div>}
                </div>
    </Layout>)
}

export default Ingredient